import React from 'react';

import { IconClose } from '../../foundations/Iconography/IconClose';
import type { RoundButtonProps } from './RoundButton/RoundButton';
import { RoundButton } from './RoundButton/RoundButton';
import * as styles from './styles';
import { ACTION_BUTTON_SIZE_MAP } from 'client-ribbons-design-system/constants/actionButtons';
import type { ActionButtonSize } from 'client-ribbons-design-system/types/actionButtons';

export interface CloseProps extends RoundButtonProps {
  size: ActionButtonSize;
}

/** @deprecated use `IconButton` instead */
export const CloseButton = ({ size, ...props }: CloseProps) => {
  const iconSize = ACTION_BUTTON_SIZE_MAP[size];
  const className = props.disabled ? styles.iconDisabled : undefined;

  return (
    <RoundButton size={size} {...props}>
      <IconClose css={className} height={iconSize} width={iconSize} />
    </RoundButton>
  );
};
